import { LuUsers2 } from "react-icons/lu";
import {
  FaRegHandshake,
  FaUserCheck,
  FaUsers,
  FaUserTie,
} from "react-icons/fa6";
import { IoChatbubbles, IoSettingsOutline } from "react-icons/io5";
import { PiLightbulbFilamentLight } from "react-icons/pi";
import {
  MdAssignmentInd,
  MdMarkUnreadChatAlt,
  MdMergeType,
  MdOutlinePermMedia,
  MdOutlineManageAccounts,
} from "react-icons/md";
import { TbMessageChatbot, TbUserPentagon } from "react-icons/tb";
import { GiGloves } from "react-icons/gi";
import {
  DashboardIcon,
  Ecounselling,
  Elearning,
  Ementoring,
  EventIcon,
} from "../../presentation/assets";
import { Image } from "react-bootstrap";
import { GrUserManager } from "react-icons/gr";
import { FaSpellCheck } from "react-icons/fa";

export const PROFILE_ACTIONS = [
  {
    name: "Settings",
    icon: <IoSettingsOutline />,
    url: "/settings",
  },
  {
    name: "Logout",
    icon: <FaUsers />,
    url: "/logout",
  },
];

export const MAIN_MENUS = [
  {
    name: "Dashboard",
    icon: <Image src={DashboardIcon} alt="" />,
    url: "/dashboard",
    roles: [
      "Admin",
      "Super Admin",
      "Coordinator",
      "Call Center Manager",
      "Counsellor",
      "Mentor",
      "User",
      "Usher",
      "Facilitator",
    ],
  },
  {
    name: "Events",
    icon: <Image src={EventIcon} alt="" />,
    url: "/events",
    roles: [
      "Admin",
      "Super Admin",
      "Coordinator",
      "Call Center Manager",
      "User",
      "Usher",
      "Facilitator",
      "Counsellor",
    ],
  },
  {
    name: "E-learning",
    icon: <Image src={Elearning} alt="" />,
    url: "https://viennabackend.nsano.cloud/lms/login/index.php",
    roles: [
      "Admin",
      "Super Admin",
      "Coordinator",
      "Call Center Manager",
      "Counsellor",
      "Mentor",
      "User",
      "Usher",
      "Facilitator",
    ],
  },
  {
    name: "E-counselling",
    icon: <Image src={Ecounselling} alt="" />,
    url: "/e-counselling/requests",
    roles: [
      "Admin",
      "Super Admin",
      "Coordinator",
      "Call Center Manager",
      "Counsellor",
      "User",
      "Usher",
      "Facilitator",
    ],
  },
  {
    name: "Users",
    icon: <LuUsers2 />,
    url: "/users",
    roles: ["Admin", "Super Admin", "Coordinator", "Call Center Manager"],
  },
];

export const EVENT_SUBMENUS = [
  {
    name: "Events",
    icon: <Image src={EventIcon} alt="" />,
    url: "/events/events",
    roles: [
      "Admin",
      "Super Admin",
      "Coordinator",
      "Call Center Manager",
      "User",
      "Usher",
      "Facilitator",
      "Counsellor",
    ],
  },
  {
    name: "Media Houses",
    icon: <MdOutlinePermMedia />,
    url: "/events/media-houses",
    roles: ["Admin", "Super Admin"],
  },
  {
    name: "Partners",
    icon: <FaRegHandshake />,
    url: "/events/partners",
    roles: ["Admin", "Super Admin"],
  },
  {
    name: "Interventions",
    icon: <GiGloves />,
    url: "/events/interventions",
    roles: ["Admin", "Super Admin"],
  },
];

export const USER_SUBMENUS = [
  {
    name: "Users",
    icon: <LuUsers2 />,
    url: "/users/users",
    roles: ["Admin", "Super Admin", "Coordinator", "Call Center Manager"],
  },
  {
    name: "User Roles",
    icon: <FaUserTie />,
    url: "/users/roles",
    roles: ["Admin", "Super Admin"],
  },
];

export const COUNSELLING_SUBMENUS = [
  {
    name: "Counsel Request",
    icon: <MdMarkUnreadChatAlt />,
    url: "/e-counselling/request",
    roles: [
      "User",
      "Usher",
      "Facilitator",
      "Coordinator",
      "Call Center Manager",
    ],
  },
  {
    name: "Counselling List",
    icon: <IoChatbubbles />,
    url: "/e-counselling/list",
    roles: ["Admin", "Super Admin"],
  },
  {
    name: "Add Counsellor",
    icon: <PiLightbulbFilamentLight />,
    url: "/e-counselling/add-counsellor",
    roles: ["Admin", "Super Admin"],
  },
  {
    name: "Counselling Type",
    icon: <MdMergeType />,
    url: "/e-counselling/counselling-type",
    roles: ["Admin", "Super Admin"],
  },
  {
    name: "Availability",
    icon: <TbUserPentagon />,
    url: "/e-counselling/counsellor-availability-calender",
    roles: ["Counsellor"],
  },
  {
    name: "Counsellor Availability",
    icon: <MdOutlineManageAccounts />,
    url: "/e-counselling/counsellor-availability",
    roles: ["Admin", "Super Admin"],
  },
  {
    name: "Assignees",
    icon: <MdAssignmentInd />,
    url: "/e-counselling/assignees",
    roles: ["Counsellor"],
  },
  {
    name: "Counsellee",
    icon: <GrUserManager />,
    url: "/e-counselling/counsellee",
    roles: ["User", "Usher", "Facilitator"],
  },
  {
    name: "Completed Counselling",
    icon: <FaSpellCheck />,
    url: "/e-counselling/completed-counselling",
    roles: ["Super Admin", "Admin"],
  },
];

export const SECONDARY_MENUS = [
  {
    name: "E-mentoring",
    icon: <img src={Ementoring} alt="" />,
    url: "/e-mentoring/groups",
    roles: [
      "Admin",
      "Super Admin",
      "Mentor",
      "Counsellor",
      "User",
      "Usher",
      "Facilitator",
    ],
  },
  {
    name: "Enquiries",
    icon: <TbMessageChatbot className="fs-6" />,
    url: "/enquiries/list",
    roles: ["Admin", "Super Admin"],
  },
  {
    name: "Make Enquiries",
    icon: <TbMessageChatbot className="fs-6" />,
    url: "/enquiries/make",
    roles: [
      "Coordinator",
      "Call Center Manager",
      "Counsellor",
      "Mentor",
      "User",
      "Usher",
      "Facilitator",
    ],
  },
];

export const MENTORING_SUBMENUS = [
  {
    name: "Groups",
    icon: <MdMarkUnreadChatAlt />,
    url: "/e-mentoring/groups",
    roles: [
      "Admin",
      "Super Admin",
      "Counsellor",
      "Mentor",
      "User",
      "Coordinator",
      "Call Center Manager",
    ],
  },
  {
    name: "List",
    icon: <IoChatbubbles />,
    url: "/e-mentoring/list",
    roles: ["Admin", "Super Admin"],
  },
  {
    name: "Add Mentor",
    icon: <FaUserCheck />,
    url: "/e-mentoring/add-mentor",
    roles: ["Admin", "Super Admin"],
  },
];
